import { v4 as uuidv4 } from 'uuid';
import { Wishlist } from '../../../../vtex-apps/peer/wishlist/Wishlist/default';
import { StackLayout } from '../../../../vtex-apps/stack-layout/StackLayout/default';
import { ProductSummaryName } from '../../../../vtex-apps/product-summary/ProductSummaryName/default';
import { FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { ProductListPrice } from '../../../../vtex-apps/product-price/ProductListPrice/default';
import { ProductSellingPrice } from '../../../../vtex-apps/product-price/ProductSellingPrice/default';
import { ProductInstallments } from '../../../../vtex-apps/product-price/ProductInstallments/default';
import { AddToCartButton } from '../../../../vtex-apps/add-to-cart-button/AddToCartButton/default';
import { ProductHighlights } from '../../../../vtex-apps/product-highlights/ProductHighlights/default';
import { ProductSummaryImage } from '../../../../vtex-apps/product-summary/ProductSummaryImage/default';
import { ProductRatingInline } from '../../../../vtex-apps/peer/reviews-and-ratings/ProductRatingInline/default';

export default function ProductSummaryShelf() {
	return {
		componentName: 'ProductSummaryShelfComponent',
		componentId: uuidv4(),
		componentGroup: 'ProductSummaryShelf',
		variables,
		props: {
			blockClass: 'product-list__summary-3',
		},
		childrenComponents: [
			Wishlist({ blockClass: 'product-shelf__wishlist-3' }),
			FlexLayoutRow({ colSizing: 'auto', blockClass: 'product-shelf__row-3' }, [
				StackLayout(
					{
						blockClass: 'product-list__shelf-3',
					},
					[
						ProductHighlights({ blockClass: 'product-list-3' }),
						ProductSummaryImage({ blockClass: 'product-list__image-3', maxHeight: 500 }),
					],
				),
				FlexLayoutRow({ blockClass: 'shelf__product-name-wrapper-3', colSizing: '100%' }, [
					ProductSummaryName({
						blockClass: 'product-summary__name-3',
						showFieldsProps: {
							showSku: false,
							showProductReference: false,
							showBrandName: true,
						},
					}),
				]),
				FlexLayoutRow(
					{
						blockClass: 'shelf__flex-row-3',
						colSizing: 'auto',
						horizontalAlign: 'left',
					},
					[
						ProductListPrice({
							blockClass: 'product-shelf__list-price-3',
						}),
						ProductSellingPrice({
							blockClass: 'product-shelf__selling-price-3',
						}),
					],
				),
				FlexLayoutRow(
					{
						blockClass: 'shelf__installments-row-3',
					},
					[
						ProductRatingInline(),
						ProductInstallments({
							blockClass: 'product-shelf__installments-3',
						}),
					],
				),

				AddToCartButton({
					unavailableText: 'Indisponível',
					customToastUrl: '/',
					text: 'Ver Detalhes',
					blockClass: 'summary__add-to-cart-btn',
					onClickBehavior: 'go-to-product-page',
				}),
			]),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--cta-color-pure', to: '--shelf-3-highlight-color', name: 'Highlight' },
			{ from: '--white', to: '--shelf-3-highlight-text-color', name: 'Highlight Text' },
			{ from: '--brand-color-secondary-pure', to: '--shelf-3-discount-color', name: 'Discount Flag' },
			{ from: '--white', to: '--shelf-3-discount-text-color', name: 'Discount Flag Text' },
			{ from: '--text-color-1', to: '--shelf-3-text-color', name: 'Text' },
			{ from: '--neutral-color-high-medium', to: '--shelf-3-border-color', name: 'Shelf Border' },
			{ from: '--text-color-1', to: '--shelf-3-installments-color', name: 'Installments' },
			{ from: '--text-color-1', to: '--shelf-3-installments-value-color', name: 'Installments Value' },
			{ from: '--text-color-1-light', to: '--shelf-3-list-price-color', name: 'List Price' },
			{ from: '--text-color-1', to: '--shelf-3-price-color', name: 'SellingPrice' },

			{ from: '--brand-color-primary-pure', to: '--shelf-3-reviews-color', name: 'Reviews' },
			{ from: '--white', to: '--shelf-3-text-cta-color', name: 'CTA Text' },
			{ from: '--cta-color-pure', to: '--shelf-3-cta-color', name: 'CTA' },
			{ from: '--cta-color-hover', to: '--shelf-3-cta-color-hover', name: 'CTA Hover' },
			{ from: '--cta-color-focus', to: '--shelf-3-cta-color-focus', name: 'CTA Focus' },
		],
	},
	{
		type: 'borderRadius',
		list: [
			{ from: '--border-radius-sm', to: '--shelf-3-border-radius', name: 'Shelf' },
			{ from: '--border-radius-sm', to: '--shelf-3-cta-border-radius', name: 'CTA' },
			{ from: '--border-radius-sm', to: '--shelf-3-highlight-border-radius', name: 'Highlight' },
		],
	},
	{
		type: 'borderWidth',
		list: [{ from: '--border-width-hairline', to: '--shelf-3-border-width', name: 'Shelf' }],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xxxs', to: '--shelf-3-highlight-font-size', name: 'Highlight' },
			{ from: '--font-size-xxxs', to: '--shelf-3-discount-fs', name: 'Discount' },
			{ from: '--font-size-xs', to: '--shelf-3-name-font-size', name: 'Product Name' },
			{ from: '--font-size-lg', to: '--shelf-3-reviews-font-size', name: 'Reviews Stars' },
			{ from: '--font-size-sm', to: '--shelf-3-list-font-size', name: 'List Price' },
			{ from: '--font-size-lg', to: '--shelf-3-selling-font-size', name: 'Selling Price' },
			{ from: '--font-size-sm', to: '--shelf-3-installments-font-size', name: 'Installments Text' },
			{ from: '--font-size-xs', to: '--shelf-3-installments-value-font-size', name: 'Installments Values' },
			{ from: '--font-size-sm', to: '--shelf-3-cta-font-size', name: 'CTA' },
		],
	},
	{
		type: 'fontWeight',
		list: [
			{ from: '--font-weight-700', to: '--shelf-3-hightlight-fw', name: 'Highlight' },
			{ from: '--font-weight-700', to: '--shelf-3-discount-fw', name: 'Discount' },
			{ from: '--font-weight-700', to: '--shelf-3-name-fw', name: 'Product Name' },
			{ from: '--font-weight-400', to: '--shelf-3-list-fw', name: 'List Price' },
			{ from: '--font-weight-400', to: '--shelf-3-selling-fw', name: 'Selling Price' },
			{ from: '--font-weight-400', to: '--shelf-3-installments-fw', name: 'Installments Text' },
			{ from: '--font-weight-700', to: '--shelf-3-installments-value-fw', name: 'Installments Values' },
			{ from: '--font-weight-700', to: '--shelf-3-cta-fw', name: 'CTA' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--shelf-3-highlight-typography', name: 'Highlight' },
			{ from: '--main-font', to: '--shelf-3-discount-typography', name: 'Discount' },
			{ from: '--main-font', to: '--shelf-3-name-typography', name: 'Product Name' },
			{ from: '--main-font', to: '--shelf-3-list-typography', name: 'List Price' },
			{ from: '--main-font', to: '--shelf-3-selling-typography', name: 'Selling Price' },
			{ from: '--main-font', to: '--shelf-3-installments-typography', name: 'Installments' },
			{ from: '--main-font', to: '--shelf-3-cta-typography', name: 'CTA' },
		],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-xxxs', to: '--shelf-3-lateral-spacing', name: 'Lateral Padding' },
			{ from: '--spacing-nano', to: '--shelf-3-cta-spacing', name: 'CTA Height' },
			{ from: '--spacing-nano', to: '--shelf-3-highlight-spacing', name: 'Highlight Height' },
			{ from: '--spacing-nano', to: '--shelf-3-discount-spacing', name: 'Discount Size' },
		],
	},
];

/**
 * {
    "add-to-list-btn#shelf-Wishlist-1": {
        "props": {
            "blockClass": "product-shelf__wishlist-1",
            "toastURL": "/wishlist"
        },
        "children": []
    },
    "product-summary-image#shelf-ProductSummaryImage-1": {
        "props": {
            "showBadge": false,
            "maxHeight": 500,
            "hoverImage": {
                "criteria": "index",
                "label": "",
                "labelMatchCriteria": "exact",
                "index": 1
            },
            "blockClass": "product-list__image-1"
        },
        "children": []
    },
    "product-summary-sku-selector#shelf-ProductSummarySkuSelector-1": {
        "props": {
            "showVariationsLabels": "none",
            "showValueForVariation": "none",
            "variationsSpacing": 5,
            "imageHeight": 40,
            "imageWidth": 40,
            "blockClass": "sku-selector__shelf-1"
        },
        "children": []
    },
    "add-to-cart-button#shelf-AddToCartButton-1": {
        "props": {
            "onClickBehavior": "go-to-product-page",
            "onClickEventPropagation": "enabled",
            "isOneClickBuy": false,
            "text": "Ver Detalhes",
            "unavailableText": "Indisponível",
            "customToastUrl": "/",
            "blockClass": "summary__add-to-cart-btn"
        },
        "children": []
    },
    "flex-layout.row#shelf-FlexLayoutRow-3": {
        "props": {
            "fullWidth": false,
            "paddingTop": {
                "desktop": 0,
                "tablet": 0,
                "phone": 0
            },
            "paddingBottom": {
                "desktop": 0,
                "tablet": 0,
                "phone": 0
            },
            "marginTop": 3,
            "marginBottom": 3,
            "colGap": {
                "desktop": 0,
                "tablet": 0,
                "phone": 0
            },
            "borderWidth": 0,
            "colSizing": "auto",
            "preventHorizontalStretch": false,
            "horizontalAlign": "left",
            "preserveLayoutOnMobile": false,
            "blockClass": "row-sku__shelf-1"
        },
        "children": [
            "product-summary-sku-selector#shelf-ProductSummarySkuSelector-1",
            "add-to-cart-button#shelf-AddToCartButton-1"
        ]
    },
    "product-highlight-text#shelf-ProductHighlightText-1": {
        "props": {
            "message": "{highlightName}",
            "blockClass": "highlight-text-product-list-1"
        },
        "children": []
    },
    "product-highlight-wrapper#shelf-ProductHighlightWrapper-1": {
        "props": {
            "blockClass": "highlight-wrapper-product-list-1"
        },
        "children": [
            "product-highlight-text#shelf-ProductHighlightText-1"
        ]
    },
    "vtex.product-highlights@2.x:product-highlights#shelf-ProductHighlights-1": {
        "props": {
            "type": "collection",
            "blockClass": "product-list-1"
        },
        "children": [
            "product-highlight-wrapper#shelf-ProductHighlightWrapper-1"
        ]
    },
    "stack-layout#shelf-StackLayout-1": {
        "props": {
            "blockClass": "product-list__shelf-1"
        },
        "children": [
            "vtex.product-highlights@2.x:product-highlights#shelf-ProductHighlights-1",
            "product-summary-image#shelf-ProductSummaryImage-1",
            "flex-layout.row#shelf-FlexLayoutRow-3"
        ]
    },
    "product-summary-image#shelf-ProductSummaryImage-3": {
        "props": {
            "showBadge": false,
            "maxHeight": 500,
            "hoverImage": {
                "criteria": "index",
                "label": "",
                "labelMatchCriteria": "exact",
                "index": 1
            },
            "blockClass": "product-list-unavailable__image-1"
        },
        "children": []
    },
    "add-to-cart-button#shelf-AddToCartButton-3": {
        "props": {
            "onClickBehavior": "go-to-product-page",
            "onClickEventPropagation": "enabled",
            "isOneClickBuy": false,
            "text": "Adicionar ao carrinho",
            "unavailableText": "Indisponível",
            "customToastUrl": "/",
            "blockClass": "shelf-btn-unavailable__shelf-1"
        },
        "children": []
    },
    "flex-layout.row#shelf-FlexLayoutRow-3": {
        "props": {
            "fullWidth": false,
            "paddingTop": {
                "desktop": 0,
                "tablet": 0,
                "phone": 0
            },
            "paddingBottom": {
                "desktop": 0,
                "tablet": 0,
                "phone": 0
            },
            "marginTop": 3,
            "marginBottom": 3,
            "colGap": {
                "desktop": 0,
                "tablet": 0,
                "phone": 0
            },
            "borderWidth": 0,
            "colSizing": "auto",
            "preventHorizontalStretch": false,
            "horizontalAlign": "left",
            "preserveLayoutOnMobile": false,
            "blockClass": "row-sku__shelf-1"
        },
        "children": [
            "add-to-cart-button#shelf-AddToCartButton-3"
        ]
    },
    "product-highlight-text#shelf-ProductHighlightText-3": {
        "props": {
            "message": "{highlightName}",
            "blockClass": "highlight-text-product-list-1"
        },
        "children": []
    },
    "product-highlight-wrapper#shelf-ProductHighlightWrapper-3": {
        "props": {
            "blockClass": "highlight-wrapper-product-list-1"
        },
        "children": [
            "product-highlight-text#shelf-ProductHighlightText-3"
        ]
    },
    "vtex.product-highlights@2.x:product-highlights#shelf-ProductHighlights-3": {
        "props": {
            "type": "collection",
            "blockClass": "product-list-1"
        },
        "children": [
            "product-highlight-wrapper#shelf-ProductHighlightWrapper-3"
        ]
    },
    "stack-layout#shelf-StackLayout-3": {
        "props": {
            "blockClass": "product-list-unavailable__shelf-1"
        },
        "children": [
            "product-summary-image#shelf-ProductSummaryImage-3",
            "flex-layout.row#shelf-FlexLayoutRow-3",
            "vtex.product-highlights@2.x:product-highlights#shelf-ProductHighlights-3"
        ]
    },
    "condition-layout.product#shelf-ConditionLayoutProduct-1": {
        "props": {
            "conditions": [
                {
                    "subject": "isProductAvailable"
                }
            ],
            "Then": "stack-layout#shelf-StackLayout-1",
            "Else": "stack-layout#shelf-StackLayout-3"
        },
        "children": []
    },
    "product-summary-name#shelf-ProductSummaryName-1": {
        "props": {
            "showFieldsProps": {
                "showSku": false,
                "showProductReference": false,
                "showBrandName": true
            },
            "tag": "h2",
            "blockClass": "product-summary__name-1"
        },
        "children": []
    },
    "vtex.store-components:product-brand#shelf-ProductBrand-1": {
        "props": {
            "displayMode": "logo",
            "fallbackToText": false,
            "height": 32,
            "loadingPlaceholder": "logo",
            "blockClass": "shelf__product-brand-1"
        },
        "children": []
    },
    "flex-layout.row#shelf-FlexLayoutRow-4": {
        "props": {
            "fullWidth": false,
            "paddingTop": {
                "desktop": 0,
                "tablet": 0,
                "phone": 0
            },
            "paddingBottom": {
                "desktop": 0,
                "tablet": 0,
                "phone": 0
            },
            "marginTop": {
                "desktop": 0,
                "tablet": 0,
                "phone": 0
            },
            "marginBottom": {
                "desktop": 0,
                "tablet": 0,
                "phone": 0
            },
            "colGap": {
                "desktop": 0,
                "tablet": 0,
                "phone": 0
            },
            "borderWidth": 0,
            "colSizing": "auto",
            "preventHorizontalStretch": false,
            "horizontalAlign": "left",
            "preserveLayoutOnMobile": true,
            "blockClass": "shelf__product-name-wrapper-1"
        },
        "children": [
            "product-summary-name#shelf-ProductSummaryName-1",
            "vtex.store-components:product-brand#shelf-ProductBrand-1"
        ]
    },
    "product-rating-inline#shelf-ProductRatingInline-1": {
        "props": {},
        "children": []
    },
    "product-list-price#shelf-ProductListPrice-1": {
        "props": {
            "alwaysShow": true,
            "blockClass": "product-shelf__list-price-1"
        },
        "children": []
    },
    "product-spot-price#shelf-ProductSpotPrice-1": {
        "props": {
            "message": "{spotPriceValue}",
            "blockClass": "product-shelf__selling-price-1",
            "alwaysShow": true
        },
        "children": []
    },
    "flex-layout.row#shelf-FlexLayoutRow-5": {
        "props": {
            "fullWidth": false,
            "paddingTop": {
                "desktop": 0,
                "tablet": 0,
                "phone": 0
            },
            "paddingBottom": {
                "desktop": 0,
                "tablet": 0,
                "phone": 0
            },
            "marginTop": {
                "desktop": 0,
                "tablet": 0,
                "phone": 0
            },
            "marginBottom": {
                "desktop": 0,
                "tablet": 0,
                "phone": 0
            },
            "colGap": 2,
            "borderWidth": 0,
            "colSizing": "auto",
            "preventHorizontalStretch": false,
            "horizontalAlign": "left",
            "preserveLayoutOnMobile": false,
            "blockClass": "shelf__flex-row-1"
        },
        "children": [
            "product-list-price#shelf-ProductListPrice-1",
            "product-spot-price#shelf-ProductSpotPrice-1"
        ]
    },
    "product-installments#shelf-ProductInstallments-1": {
        "props": {
            "markers": [
                "bold"
            ],
            "message": "{installmentsNumber}x de <bold>{installmentsTotalValue}</bold>",
            "installmentsCriteria": "max-quantity-without-interest",
            "blockClass": "other-installment-value__shelf-1"
        },
        "children": []
    },
    "flex-layout.row#shelf-FlexLayoutRow-6": {
        "props": {
            "fullWidth": false,
            "paddingTop": {
                "desktop": 0,
                "tablet": 0,
                "phone": 0
            },
            "paddingBottom": {
                "desktop": 0,
                "tablet": 0,
                "phone": 0
            },
            "marginTop": 3,
            "marginBottom": {
                "desktop": 0,
                "tablet": 0,
                "phone": 0
            },
            "colGap": 3,
            "borderWidth": 0,
            "colSizing": "auto",
            "preventHorizontalStretch": false,
            "horizontalAlign": "left",
            "preserveLayoutOnMobile": true,
            "blockClass": "flex-row-other-installment__shelf-1"
        },
        "children": [
            "product-installments#shelf-ProductInstallments-1"
        ]
    },
    "condition-layout.product#shelf-ConditionLayoutProduct-3": {
        "props": {
            "conditions": [
                {
                    "subject": "isProductAvailable"
                }
            ],
            "Then": "flex-layout.row#shelf-FlexLayoutRow-6",
            "Else": null
        },
        "children": []
    },
    "flex-layout.row#shelf-FlexLayoutRow-1": {
        "props": {
            "fullWidth": false,
            "paddingTop": {
                "desktop": 0,
                "tablet": 0,
                "phone": 0
            },
            "paddingBottom": {
                "desktop": 0,
                "tablet": 0,
                "phone": 0
            },
            "marginTop": {
                "desktop": 0,
                "tablet": 0,
                "phone": 0
            },
            "marginBottom": {
                "desktop": 0,
                "tablet": 0,
                "phone": 0
            },
            "colGap": {
                "desktop": 0,
                "tablet": 0,
                "phone": 0
            },
            "borderWidth": 0,
            "colSizing": "auto",
            "preventHorizontalStretch": false,
            "horizontalAlign": "left",
            "preserveLayoutOnMobile": false,
            "blockClass": "product-shelf__row-1"
        },
        "children": [
            "condition-layout.product#shelf-ConditionLayoutProduct-1",
            "flex-layout.row#shelf-FlexLayoutRow-4",
            "product-rating-inline#shelf-ProductRatingInline-1",
            "flex-layout.row#shelf-FlexLayoutRow-5",
            "condition-layout.product#shelf-ConditionLayoutProduct-3"
        ]
    },
    "product-summary.shelf#shelf-ProductSummaryShelfComponent-1": {
        "props": {
            "blockClass": "product-list__summary-1"
        },
        "children": [
            "add-to-list-btn#shelf-Wishlist-1",
            "flex-layout.row#shelf-FlexLayoutRow-1"
        ]
    }
}
 */
